import type { HttpErrorResponse } from '@angular/common/http';
import type { EduCoursePayment } from '@common/types/payment-form.type';

import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map } from 'rxjs/operators';

import { EduCoursePaymentsHttpService } from './edu-course-payments.http.service';
import { EduCoursePaymentsService } from './edu-course-payments.service';

import EduCoursePaymentsActions from './edu-course-payments.actions';

@Injectable()
export class EduCoursePaymentsCollectionEffect {
    private readonly actions$ = inject(Actions);
    private readonly eduCoursePaymentsHttpService = inject(EduCoursePaymentsHttpService);
    private readonly eduCoursePaymentsService = inject(EduCoursePaymentsService);

    public readonly loadEduCoursePaymentsRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EduCoursePaymentsActions.loadCollectionRequest),
            filter(({ courseId }) => Boolean(courseId)),
            exhaustMap(({ courseId }) =>
                this.eduCoursePaymentsHttpService.getEduCoursePayments(courseId).pipe(
                    map((eduCoursePayments: EduCoursePayment[]) =>
                        EduCoursePaymentsActions.loadCollectionSuccess({
                            courseId,
                            eduCoursePayments:
                                this.eduCoursePaymentsService.mapEduCoursePaymentsToEduCoursePaymentEntities(
                                    eduCoursePayments
                                ),
                        })
                    ),
                    catchError((error: HttpErrorResponse) => [
                        EduCoursePaymentsActions.loadCollectionFailure({ courseId, error: error.message }),
                    ])
                )
            )
        )
    );
}
